import { useNavigate } from 'react-router'
import React from 'react'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import {
  SupportHomePageContainer,
  SupportHomePageItem,
} from 'src/supportPortal/views/home/styledComponents'
import useServerAuth from 'src/customHooks/useServerAuth'

export default function PatientManagementNavPage() {
  const navigate = useNavigate()
  const { allRolesInBoolean } = useServerAuth()
  
  return (
    <>
      <SupportHeader heading={'Patient Management'} showBackButton />
      <SupportHomePageContainer>
        {allRolesInBoolean.isL2TherapySupport && (
          <SupportHomePageItem onClick={() => navigate('/support-home/patient-management/patients')}>
            Patients
          </SupportHomePageItem>
        )}
        {(allRolesInBoolean.isL1TherapySupport ||
          allRolesInBoolean.isL2TherapySupport ||
          allRolesInBoolean.isL3TherapySupport) && (
          <SupportHomePageItem onClick={() => navigate('/support-home/patient-management/therapy-scheduled-patients')}>
            Therapy Scheduled Patients
          </SupportHomePageItem>
        )}
        {(allRolesInBoolean.isL1TherapySupport ||
          allRolesInBoolean.isL2TherapySupport ||
          allRolesInBoolean.isL3TherapySupport) && (
          <SupportHomePageItem onClick={() => navigate('/support-home/patient-management/consultation-scheduled-patients')}>
            Consultation Scheduled Patients
          </SupportHomePageItem>
        )}
      </SupportHomePageContainer>
    </>
  )
}

